<template>
<div>
        <v-row justify="center">
          <v-col cols="12" sm="8" md="7" lg="5" xl="4">
          <v-card
          class="mb-12"
          color=""
          >
         <v-card-title>STEP:1 メールアドレス登録</v-card-title>
          <v-card-text>
          <v-container pt-n5 mt-0> 

    <v-form
      ref="form"
      v-model="isValidMail"
    >

            <v-row dense>
              <v-col cols="12" sm="12" md="8" lg="8" xl="8" >
                <v-text-field
                :disabled="!isSendMail"
                prepend-icon="mdi-email" 
                v-model="user.email"
                :rules="mailRules"
                label="メールアドレスを入力してください。"
                required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                 <v-btn
                  v-if ="!isCountErr"
                  :disabled="!isValidMail || loading"
                  color="primary"
                  @click="sendMail()"
                  >認証メールを送る
                </v-btn>
                <v-btn
                  v-if ="isCountErr"
                  @click="changeMail()"
                  x-small
                  >メールアドレスを修正する
                </v-btn> 
              </v-col>

            </v-row>
            <v-row v-if="!AuthMail" class="text_red"> {{message}} </v-row> 
            <v-row v-if="!AuthMail" class="text_red"> {{message2}} </v-row> 
            </v-form>
            <div v-if="!isNotAuthMail">
              <v-form
              ref="form"
              v-model="isValidAuth"
              @submit.prevent
            >
            <v-row>
              <span class="text_bule">メールに記載の4桁の番号を入力してください。</span>
            </v-row>
            <v-row  dense>
              <v-col cols="12" sm="7" md="7" lg="7" xl="7">
                  <v-form
                    ref="form"
                    v-model="isResist"
                    @submit.prevent
                  >
                <v-text-field
                :disabled="!isCountErr"
                prepend-icon="mdi-key" 
                v-model="resist"
                label="メールに記載の4桁の番号を入力してください。"
                persistent-hint
                required
                :rules="resistRules"
                ></v-text-field>
                        </v-form>

              </v-col>
              <v-col cols="12" sm="8" md="7" lg="4" xl="4">
                 <v-btn
                  :disabled="!isAuthCode"
                  color="primary"
                  @click="authMail()"
                  small
                  >番号を認証する。
                </v-btn>  
              </v-col>
            </v-row>


                  <v-row class="text_red">{{err_message}}</v-row>


    
       </v-form>
      </div>
              <v-row justify="center">
        <v-col cols="11">
          <span v-show="!AuthMail">
             フリーメール(ヤフーメール hotmail Gmailなど)をお使いのお客様より弊社からのご案内がお届け出来ていないとのご連絡を多数頂いております。<br>
            【timerepair@naganoshouten.com 】より【認証メール】を送信致しております。<br>
             メールが届かないお客様は、受信許可設定または迷惑メールフォルダをご確認ください。.
          </span>
        </v-col>
        </v-row>
      <div v-if="AuthMail">
       <v-form
        ref="form"
        v-model="isUser"
       >
              <v-row no-gutters>
              <v-col class="d-flex"  cols="11"   >
                 <v-btn color="red" dark text x-small>必須</v-btn>
              </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col >
               <v-text-field
                 prepend-icon="mdi-account-key" 
                 v-model="user.password"
                :append-icon="isShowPass ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="passRules"
                :type="isShowPass ? 'text' : 'password'"
                label="パスワードを入力してください。"
                hint="半角英数8文字以上"
                counter
                @change="Verify"
                @click:append="isShowPass = !isShowPass;"
                dense
                
              >         
              </v-text-field>
              </v-col>  
              </v-row>

              <v-row no-gutters>
              <v-col class="d-flex"  cols="11"   >
                 <v-btn color="red" dark text x-small>必須</v-btn>
              </v-col>
              </v-row>

              <v-row no-gutters>
              <v-col >
               <v-text-field
                 prepend-icon="mdi-account-key" 
                 v-model="user.passwordverify"
                :append-icon="isShowPass ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="passRules"
                :type="isShowPass ? 'text' : 'password'"
                label="確認パスワードを入力してください。"
                hint="半角英数8文字以上"
                counter
                @change="Verify"
                @click:append="isShowPass = !isShowPass;"
                dense
              >
              </v-text-field>
              </v-col>  
              </v-row>
              <v-row v-show="user.password!=user.passwordverify" justify="center">
                <v-col cols="11" class="text_red">パスワードが一致しません。</v-col></v-row>
                <v-row no-gutters> <v-btn color="red" dark text x-small>必須（氏名）</v-btn></v-row>
              <v-row no-gutters>

                <v-col cols="12" >
                <v-card-actions>
                <v-text-field
                dense
                v-model="user.name_first"
                :rules="nameRules"
                label="名字"
                @change="Verify"
                required
                class="mr-2"
                >

                </v-text-field>

                <v-text-field
                dense
                v-model="user.name_last"
                :rules="nameRules"
                label="名前"
                @change="Verify"
                required
                >
                </v-text-field>
                </v-card-actions>
                </v-col>
              </v-row>
                  <v-row no-gutters> <v-btn color="red" dark text x-small>必須(フリガナ）</v-btn></v-row>
              <v-row no-gutters>
                <v-col cols="12">
                <v-card-actions>  
                <v-text-field 
                v-model="user.name_first_kana"
                :rules="nameRules"
                label="ミョウジ（カナ）"
                @change="Verify"
                required
                class="mr-2"
                >
                </v-text-field> 
                <v-text-field               
                v-model="user.name_last_kana"
                :rules="nameRules"
                label="ナマエ（カナ）"
                @change="Verify"
                required
                >
                </v-text-field>
                </v-card-actions>
                </v-col>
              </v-row>

          </v-form>

              <v-row>
                <v-col cols="12" class="mr-1">
                <v-btn
                  color="primary"
                  @click="e1 = 2; toParent()"
                  bottom right
                  absolute
                  :disabled="!isAuth"
                  >次へ→
                </v-btn>  
                </v-col>
              </v-row>
        </div>
            </v-container>
          </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        </div>
</template>

<script>

import doAxios from '@/components/modules/AxiosPost'
import setAddress from '@/components/modules/setAddress'
  export default {
    data () {

      return {
        isAuthCode:false, //false
        isPassword:false,
        isShowPass: false,
        isActive:false,
        isUser:false,
        isAuth:false, //false
        isPass:false,
        isNotAuthMail:true, //true,//
        isCountErr:false, //false
        AuthMail:false, //false,//
        isValidAuth:false, 
        isValidMail:false,
        isResist:false,
        loading: false,
        isSendMail: true, //true
        errCount:"0",
        message:"",
        message2:"",
        err_message:"",
        user:[],
        address1:"",
        id:"mitukenaidene",
        results:[],
        watchSymptoms:[],
        resist:"",
        telRules: [
        v => !!v || '必須項目です。',
        v => (v && v.length <= 11) || 'Name must be less than 11 characters',
        ],

        mailRules: [
        v => !!v || '必須項目です。',
        v => /.+@.+\..+/.test(v) || '',
        v => (v && v.length <= 100 )|| 'Email be less than 100 characters',
        ],
        resistRules: [
        v => !!v || '必須項目です。',
        v => (v && v.length <= 4 )|| 'RESIST CODE be less than 4 characters',
        ],
        nameRules: [
        v => !!v || '必須項目です。',
        v => (v && v.length <= 30) || 'Name must be less than 30 characters',
        ],
        passRules: [
         v=> !!v|| 'Required.',
         v => (v && v.length >= 8 )|| 'Min 8 characters',
        ],
      }      
    },
       
  mixins: [doAxios,setAddress],

  watch: {
    resist: function () {
        this.isAuthCode =true
    }
  },

  methods: {

    async sendMail(){
        this.id= await this.create_privateid(4);
        const setData = {'mailto':this.user.email,'AuthVerifi':this.id};
        const php = 'push_mail/sendMail';
        this.results = await this.doAxios({php,setData});
        this.setAddress('sendMail')
        if(this.results == 200){
        this.isSendMail= false;
        this.isValidMail=false;
        this.isCountErr =true;
        this.isNotAuthMail =false

        this.message = "メールを送信しました。"
        this.message2= "迷惑メールボックスに振り分けられる場合があります。メールが届かない場合はメールアドレス確認の上再度送信してください。"
        }
        if(this.results.code == 400){
          this.err_message ="このアドレスは使用できません。"
          this.user.password =""
        }else if(this.results.code == 500){
          this.err_messager ="サーバーエラーです。しばらくたってから再度送信ししてください。"
        }
    },
    authMail(){
      if(this.errCount ==3){
        this.isCountErr =false;
        this.isValidMail= true;
        this.isSendMail= true;
        this.message = "番号が一致しませんでした。再度メールを送信してください。"
      }else{
         if(this.id===this.resist && this.id.length <=4){
           this.setAddress('authMail')
           this.AuthMail=true
           this.isNotAuthMail=true
          }else{
           this.errCount++
           this.isAuthCode = false
           this.message = "番号が一致しません。"
         }
      }
    },
    changeMail(){
        this.isCountErr =false;
        this.isValidMail= true;
        this.isSendMail= true;
        this.isNotAuthMail=true;
        this.AuthMail=false;
        this.isAuthCode =false
        this.id="";
        this.resist="";
        this.message=""
        this.message2=""
        this.err_message=""
    },
    Verify(){
        this.isAuth =false
        if(this.user.password === this.user.passwordverify){
          this.message=null
          this.isPass =true
        }else{
          this.message ="パスワードが一致しません。"
          this.isPass =false
        }
        if(this.isPass === true && this.isUser == true){
          this.isAuth = true
        }else{
           this.isAuth =false
        }
    },

    toParent(){
       window.scrollTo({top: 0,behavior: "smooth"})   
       this.ThisEmit = {btn:this.e1,user:this.user}
       this.setAddress('nextStep2')
       this.$emit("get-step1", this.ThisEmit);
 
   },
   create_privateid( n ){
    const CODE_TABLE = "0123456789"
        + "ABCDEFGHJKLMNOPQRSTUVWXYZ";
    let r = "";
    for (let i = 0, k = CODE_TABLE.length; i < n; i++){
        r += CODE_TABLE.charAt(Math.floor(k * Math.random()));
	}
	return r;
}
  }
  }
  </script>
  
<style scoped lang="scss">

.text_red{
  color:#ff4444;
  font-size:8pt;
}
.text_bule{
  color:#001aff;
}
</style>
